import InspectionFlwBaselineRepo from "../data/repo/InspectionFlwBaselineRepo";
import { InspectionFlwBaselineControlPointWriteModel } from "../data/entities/InspectionFlwBaselineModel";

export class InspectionFlwBaselineService {

  async getControlPoints(inspectionId: number) {
    return await new InspectionFlwBaselineRepo().getControlPoints(inspectionId);
  }

  async addControlPoint(inspectionId: number, body: InspectionFlwBaselineControlPointWriteModel) {
    return await new InspectionFlwBaselineRepo().addControlPoint(inspectionId, body);
  }

  async updateControlPoint(inspectionId: number, cpId: number, body: InspectionFlwBaselineControlPointWriteModel) {
    return await new InspectionFlwBaselineRepo().updateControlPoint(inspectionId, cpId, body);
  }

  async deleteControlPoint(inspectionId: number, cpId: number) {
    return await new InspectionFlwBaselineRepo().deleteControlPoint(inspectionId, cpId);
  }

  async getFlwBaselineChart(inspectionId: number) {
    return await new InspectionFlwBaselineRepo().getFlwBaselineChart(inspectionId);
  }
}

export default InspectionFlwBaselineService;
